/* Brand typography for catalogue and asynchronously rendered app text. Never rewrite URLs or identifiers. */
(() => {
  const excluded = 'script,style,code,pre,textarea,input,[contenteditable="true"],noscript';
  const brand = value => value.replace(/\bGroomSkull(?![\w./-])(?:®+)?/gi, 'GroomSkull®');
  const fixText = node => {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const old = node.nodeValue;
    if (!/groomskull/i.test(old)) return;
    let updated = brand(old);
    if (/groomskull\s*$/i.test(old) && node.nextSibling?.nodeType === 1 && node.nextSibling.tagName === 'SUP' && node.nextSibling.textContent.trim() === '®') updated = updated.replace(/®(\s*)$/, '$1');
    if (updated !== old) node.nodeValue = updated;
  };
  const fixElement = el => {
    if (el.matches(excluded) || el.closest(excluded)) return;
    for (const attr of ['alt','title','aria-label']) {
      const old = el.getAttribute(attr);
      if (old && /groomskull/i.test(old)) {const updated = brand(old); if(updated !== old) el.setAttribute(attr,updated);}
    }
    if (el.matches('a[href*="/policies/"]')) {
      el.target = '_blank'; el.rel = 'noopener';
      const label = el.getAttribute('aria-label') || el.textContent.trim();
      const suffix = /^fr(?:-|$)/i.test(document.documentElement.lang) ? 'nouvel onglet' : 'new tab';
      if (!label.includes(suffix)) el.setAttribute('aria-label',`${label} (${suffix})`);
    }
  };
  const walk = root => {
    if(root.nodeType === 3) {fixText(root); return;}
    if(root.nodeType !== 1 || root.matches(excluded)) return;
    fixElement(root);
    const walker = document.createTreeWalker(root,NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    let node;
    while((node = walker.nextNode())) {if(node.nodeType === 3) fixText(node); else fixElement(node);}
  };
  walk(document.body);
  document.title = brand(document.title);
  new MutationObserver(records => {
    for(const record of records) {
      if(record.type === 'characterData') fixText(record.target);
      else if(record.type === 'attributes') fixElement(record.target);
      else record.addedNodes.forEach(walk);
    }
  }).observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['alt','title','aria-label']});
})();
